<template>
  <footer style="background-image: url('https://cdn.proxyscrape.com/img/footer-bg.jpg');">
    <div class="container">
      <div class="footer-main">
        <div class="row">
          <div class="col-lg-3 col-md-12 col-12">
            <div class="itemcard">
              <div class="logo">
                <a href="/home" id="bottomlogo"><img src="https://cdn.proxyscrape.com/img/logo/light_text_logo.png" alt="proxyscrape light logo"></a>
              </div>
              <p>Looking for help with our proxies or want to help? Here are your options:</p>
              <div>
                <div class="footer-links">
                  <ul>
                    <li><a href="/help-center">Visit help center</a></li>
                    <li><a href="https://support.proxyscrape.com/">Knowledge base</a></li>
                    <li><a href="https://www.linkedin.com/company/proxyscrape/">LinkedIn</a></li>
                    <li><a href="/contact">Contact</a></li>

                  </ul>
                </div>
                <p>Thanks to everyone for the amazing support!</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12 ">
            <div class="itemcard mgl30">
              <h2>Quick Links</h2>
              <div class="footer-links">
                <ul>
                  <li><a href="/free-proxy-list">Free proxy list</a></li>
                  <li><a href="/web-proxy">Web proxy</a></li>
                  <li><a href="/premium?ref=footer">Premium</a></li>
                  <li><a href="/online-proxy-checker">Online Proxy Checker</a></li>
                  <li><a href="https://docs.proxyscrape.com/" target="_blank">API</a></li>
                  <li><a href="/login">Login</a></li>
                  <li><a href="/blog">Blog</a></li>
                  <li><a href="/proxy-types">Proxy types</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-12 ">
            <div class="itemcard mgl30">
              <h2>Important</h2>
              <div class="footer-links">
                <ul>
                  <li><a href="/cookie-policy">Cookie policy</a></li>
                  <li><a href="/disclaimer">Disclaimer</a></li>
                  <li><a href="/privacy-policy">Privacy policy</a></li>
                  <li><a href="/terms-and-conditions">Terms and conditions</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="notranslate"> © Copyright 2021 - <a href="https://thip.dev">Thib BV</a> | Brugstraat 18
          | 2812 Mechelen | VAT BE 0749 716 760</p>
      </div>
    </div>
  </footer>
</template>

<script lang='ts' setup>

</script>

<style scoped>

</style>
